import { render, staticRenderFns } from "./scRotator.vue?vue&type=template&id=0e019270&scoped=true&"
import script from "./scRotator.vue?vue&type=script&lang=js&"
export * from "./scRotator.vue?vue&type=script&lang=js&"
import style0 from "./scRotator.vue?vue&type=style&index=0&id=0e019270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e019270",
  null
  
)

export default component.exports